/* pc-ln-close forks (13 Oct 2026): play once when the section comes into view.
   [data-lnc-play] gets .is-armed (start state) only when it is below the fold with motion allowed,
   then .is-lit when 30% is visible. No JS / reduced motion: neither class, so everything is final.
   [data-lnc-loop] (always on): the computer switches off once, then a sample alert reaches Edge every
   ~5s while the section is on screen; strings are the hero demo's composer canon. */
(function () {
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LOG = ['Alert received · buy XAUUSD 1 lot', 'Alert received · sell BTCUSD 0.01 lots', 'Alert received · close EURUSD longs', 'Alert received · buy NAS100 0.01 lots'];
  function steps(el) {
    var list = el.querySelector('.lnc-steps__list'), run = el.querySelector('.lnc-steps__run'), n = el.querySelector('.lnc-step__n');
    if (!list || !run || !n) return;
    var l = list.getBoundingClientRect(), r = n.getBoundingClientRect(), e = el.getBoundingClientRect();
    run.style.setProperty('--lnc-run-y', Math.round(r.top + r.height / 2 - e.top) + 'px');
    run.style.left = Math.round(l.left - e.left) + 'px'; run.style.right = 'auto';
    run.style.width = Math.round(l.width) + 'px'; run.style.setProperty('--lnc-run-w', Math.round(l.width) + 'px');
  }
  function loop(el) {
    var log = el.querySelector('[data-lnc-log]'), pc = el.querySelector('[data-lnc-pc]'), i = 0, t = null, vis = false;
    el.classList.add('is-on'); if (pc) pc.textContent = 'On';
    setTimeout(function () { el.classList.remove('is-on'); if (pc) pc.textContent = 'Off'; }, 1300);
    function beat() {
      t = null; if (!vis || document.hidden) return;
      el.classList.remove('is-pulse'); void el.offsetWidth;
      if (log) log.textContent = LOG[i++ % LOG.length];
      el.classList.add('is-pulse');
      t = setTimeout(beat, 5200);
    }
    new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis && !t) t = setTimeout(beat, 2000); }, { threshold: 0.2 }).observe(el);
    document.addEventListener('visibilitychange', function () { if (!document.hidden && vis && !t) t = setTimeout(beat, 1200); });
  }
  function init(el) {
    if (el.hasAttribute('data-lnc-init')) return; el.setAttribute('data-lnc-init', '');
    if (RM || !('IntersectionObserver' in window)) return;
    /* decide from the first observation, not from the scroll position at init: an anchor jump can land
       after this runs. Off screen = arm (hiding it is invisible), then light up at 30%. Already showing
       = leave it finished (never hide something the visitor is looking at). */
    var first = true;
    var io = new IntersectionObserver(function (es) {
      var e = es[0];
      if (first) {
        first = false;
        if (e.isIntersecting) { io.disconnect(); if (el.hasAttribute('data-lnc-loop')) loop(el); return; }
        el.classList.add('is-armed'); return;
      }
      if (e.intersectionRatio < 0.3) return;
      io.disconnect();
      if (el.classList.contains('lnc-steps')) steps(el);
      el.classList.add('is-lit');
      if (el.hasAttribute('data-lnc-loop')) loop(el);
    }, { threshold: [0, 0.3] });
    io.observe(el);
  }
  function all(r) { (r || document).querySelectorAll('[data-lnc-play]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
